import { Link } from 'react-router-dom';
// utils
import { cn } from '@/utils';
import { PATHS } from '@/constants';
import { useReportContext } from '@/pages/Report/Report.context';
// styles
import styles from '@/pages/Report/components/SessionDistribution/components/ByType/components/SessionTypeItem/SessionTypeItem.module.css';

interface SessionTypeItemProps {
    name: string;
    color: string;
    value: string;
    isLead: boolean;
}

const SessionTypeItem = ({
    name,
    color,
    value,
    isLead
}: SessionTypeItemProps) => {
    const ctx = useReportContext();
    const queryString = `?from_datetime=${ctx.from_datetime}&to_datetime=${ctx.to_datetime}&session_types[]=${name}&is_lead=${isLead}`;
    return (
        <Link
            className={cn(
                'flex capitalize justify-between gap-4 px-4 py-3 no-underline text-black w-format-number',
                styles.item
            )}
            style={{
                backgroundColor: color
            }}
            to={`${PATHS.sessions}${queryString}`}
        >
            {name.split('_').join(' ')}
            <span>{value}</span>
        </Link>
    );
};

export default SessionTypeItem;
